import { NgModule } from '@angular/core';
import { NotificationPersonalSubscriberPipe } from 'src/app/shared/pipes/notification-personal-subscriber.pipe';
import { ActivatedPipe } from 'src/app/shared/pipes/notification-subscribtion.pipe';
import { LaaSSharedModule } from './../../shared/laas-shared.module';

import { NotificationSubscribtionRoutingModule } from './notification-subscribtion-routing.module';
import { NotificationSubscribtionComponent } from './notification-subscribtion.component';


@NgModule({
  declarations: [
    NotificationSubscribtionComponent,
    ActivatedPipe,
    NotificationPersonalSubscriberPipe
  ],
  imports: [
    NotificationSubscribtionRoutingModule,
    LaaSSharedModule
  ],
  exports: [
    NotificationSubscribtionComponent
  ]
})
export class NotificationSubscribtionModule { }
